module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Event_16"],"rect":[{"$":{"x":"7","y":"11","width":"2","height":"2","transform":"translate(16 24) rotate(180)","fill":"#464646"}}],"path":[{"$":{"d":"M7,5H9V9H7Zm8-4V15H1V1H3V0H6V1h4V0h3V1ZM11,3h1V1H11ZM4,3H5V1H4ZM14,4H2V14H14Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Event_16.svg
// module id = 96NJ
// module chunks = 1